export default "__VITE_ASSET__e5lRWxWE__"